import React, { useState, useEffect } from "react";
import {
  Col,
  Row
} from "reactstrap";
import "antd/dist/antd.css";
import { connect } from "react-redux";
import Loader from "../../components/Loader/Loader";
import IntegrationGoupImg from "../../assets/images/all-integ.png";
import { Link } from "react-router-dom";
import Zoom from "./components/Zoom";
import Zapier from "./components/Zapier";
import Stripe from "./components/Stripe";
import GoogleMeet from "./components/GoogleMeet";
import OutlookCalendar from "./components/OutlookCalendar";
import GoogleCalendar from "./components/GoogleCalendar";
import ExchangeCalendar from "./components/ExchangeCalendar";
import Office365Calendar from "./components/Office365Calendar";
import MicrosoftTeams from "./components/MicrosoftTeams";
import Paypal from "./components/Paypal";
import { withRouter } from "../../utils/utility";
import { sendGetRequest } from "../../actions/app-actions";
import { getAdminBusinessId } from "../../utils/authHelper";
 
const Integrations = (props) => {
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [page, setPage] = useState("all");
  const [connectedVenues, setConnectedVenues] = useState([]);

  useEffect(() => {
    const { sendGetRequest } = props;
    sendGetRequest({
        url: `/admin/connected-venues/${getAdminBusinessId()}`,
        onSuccess: function (response) {
          setConnectedVenues(response.data);
        },
        onError: function (error) {
        },
    });
  }, []);
  
  return (
    <Row className="all-integ">
      <Loader isShowLoader={isPageLoading} />
      <Col sm="12">
        <div className="integ-banner">
          <Row className="justify-content-between align-items-center">
            <Col md="8" lg="7">
              <h1>
                Connect <span className="text-brand">MeetOcto</span>{" "}
                <br className="d-none d-lg-block" /> to your favorite
                application.
              </h1>
            </Col>
            <Col md="4" lg="5">
              <img src={IntegrationGoupImg} alt="All Integration" />
            </Col>
          </Row>
        </div>
      </Col>
      <Col sm="12">
        <Row>
          <Col md="4" xl="3">
            <div className="int-sidebar">
              <Link
                to="#"
                className={`${page === "all" ? "active" : ""}`}
                onClick={() => setPage("all")}
              >
                All Integrations
              </Link>
              <Link
                to="#"
                className={`${page === "calendars" ? "active" : ""}`}
                onClick={() => setPage("calendars")}
              >
                Calendars
              </Link>
              <Link
                to="#"
                className={`${page === "most-use" ? "active" : ""}`}
                onClick={() => setPage("most-use")}
              >
                Most Use
              </Link>
              <Link
                to="#"
                className={`${
                  page === "video-conferencing" ? "active" : ""
                }`}
                onClick={() => setPage("video-conferencing")}
              >
                Video conferencing
              </Link>
              {/* <Link
                to="#"
                className={`${
                  page === "extensions-app" ? "active" : ""
                }`}
                onClick={() => setPage("extensions-app")}
              >
                Extensions and apps
              </Link> */}
              {/* <Link
                to="#"
                className={`${page === "email" ? "active" : ""}`}
                onClick={() => setPage("email")}
              >
                Email messaging
              </Link> */}
              <Link
                to="#"
                className={`${page === "payments" ? "active" : ""}`}
                onClick={() => setPage("payments")}
              >
                Payments
              </Link>
              {/* <Link
                to="#"
                className={`${page === "api" ? "active" : ""}`}
                onClick={() => setPage("api")}
              >
                API and connectors
              </Link> */}
            </div>
          </Col>
          <Col md="8" xl="9">
            <div className="int-content">
              <h2>All Integrations</h2>
              <Row className="mb-5">
                {page === "all" && (
                  <>
                    <GoogleCalendar connectedVenues={connectedVenues} />
                    <GoogleMeet connectedVenues={connectedVenues} />
                    <Office365Calendar connectedVenues={connectedVenues} />
                    {/* <OutlookCalendar /> */}
                    {/* <ExchangeCalendar /> */}
                    <Zapier />
                    <Zoom connectedVenues={connectedVenues}/>
                    <MicrosoftTeams connectedVenues={connectedVenues}/>
                    <Stripe connectedVenues={connectedVenues}/>
                    <Paypal connectedVenues={connectedVenues}/>
                  </>
                )}
                {page === "calendars" && (
                  <>
                    <GoogleCalendar connectedVenues={connectedVenues} />
                    <Office365Calendar connectedVenues={connectedVenues} />
                    {/* <OutlookCalendar /> */}
                    {/* <ExchangeCalendar /> */}
                  </>
                )}
                {page === "most-use" && (
                  <>
                    <GoogleCalendar connectedVenues={connectedVenues} />
                    <Zoom connectedVenues={connectedVenues}/>
                    <GoogleMeet connectedVenues={connectedVenues}/>
                  </>
                )}
                {page === "video-conferencing" && (
                  <>
                    <Zoom connectedVenues={connectedVenues}/>
                    <MicrosoftTeams connectedVenues={connectedVenues}/>
                    <GoogleMeet connectedVenues={connectedVenues}/>
                  </>
                )}

                {page === "extensions-app" && (
                  <>
                    <OutlookCalendar />
                  </>
                )}
                {page === "email" && (
                  <>
                    <OutlookCalendar />
                  </>
                )}
                {page === "payments" && (
                  <>
                    <Stripe connectedVenues={connectedVenues}/>
                    <Paypal connectedVenues={connectedVenues} />
                  </>
                )}
                {page === "api" && (
                  <>
                    <Zapier />
                  </>
                )}
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};


export default connect(null, {
  sendGetRequest
})(withRouter(Integrations));

